
import { toggleBodyClass } from './_class/_toggle';
import './_fonts.js';

document.querySelector('.cover-title').addEventListener('click', toggleBodyClass('cover-close'));

function getRandomInt(max) {
  return Math.floor(Math.random() * Math.floor(max));
}

const letter = [];
let count = 0;

const letterRandomTransformToItalic = () => {
  [
    'm','i','c-cap','o','period',
    'w','r','k','s',
    'a','b','u','t',
    'f','e','n','c'
  ].forEach((item, i) => {
    document.querySelectorAll(`.letter-${item}`).forEach((item, i) => {
      let letter;
      letter = item.alt != '.' ? item.alt : 'period';
      letter = item.alt != 'C' ? letter : 'c-cap';
      if(1 === getRandomInt(2)){
        const regexp = new RegExp('/(' + letter + '.svg)');
        item.src = item.src.replace(regexp,"/i-$1");
      }else{
        item.src = item.src.replace('/i-',"/");
      }
    });
  });
  if(!!window.debug) console.log(++count)
}

const debug = ('mico.lc' === window.location.hostname || 'mico.planpotdesignworks.com' === window.location.hostname);
let interval = 500;
if(debug && typeof URLSearchParams != 'undefined'){
  const searchParams = new URLSearchParams(window.location.search);
  if(searchParams.has('i')){
    const param = Number(searchParams.get('i'));
    if(10 <= param) interval = param;
    console.log('set interval:',param);
  }
}
const loop = window.setInterval(letterRandomTransformToItalic, interval);
letterRandomTransformToItalic();
if(!!window.debug) console.log(loop);
document.addEventListener("load", () => {
  console.log('load');
});
